// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { AllergyUpdate } from '@quromedical/models';
import { ConfirmationButton } from 'components/input';
import { ColumnType } from 'components/table';
import { Skeleton, SkeletonProvider } from 'design-system';
import { useCallback } from 'react';
import { strings } from 'strings';

export interface AllergyTable {
  id: string;
  name: string;
  type?: string;
  severity?: string;
  recorder?: string;
}

interface ActionCellRow {
  id: string;
}

interface ActionCellProps {
  row: {
    original: ActionCellRow;
  };
  update: (input: AllergyUpdate) => Promise<void>;
  isLoading: boolean;
}

type CreateAllergyColumnsProps = Omit<ActionCellProps, 'row'>;

const ActionCell: React.FC<ActionCellProps> = ({ row, update, isLoading }) => {
  const { id } = row.original;

  const onSubmit = useCallback(async () => {
    update({ id, status: 'resolved' });
  }, [id, update]);

  return (
    <SkeletonProvider loading={isLoading}>
      <Skeleton>
        <ConfirmationButton
          status="status-critical"
          title={strings.AllergyDialogTitle}
          message={strings.AllergyDialogMessage}
          onSubmit={onSubmit}
          buttonText={strings.AllergyDialogButtonText}
        />
      </Skeleton>
    </SkeletonProvider>
  );
};

export const createAllergyColumns = ({
  update,
  isLoading,
}: CreateAllergyColumnsProps): ColumnType<AllergyTable>[] => [
  {
    header: strings.AllergyName,
    accessor: 'name',
  } as ColumnType<AllergyTable, 'name'>,
  {
    header: strings.AllergyType,
    accessor: 'type',
  } as ColumnType<AllergyTable, 'type'>,
  {
    header: strings.AllergySeverity,
    accessor: 'severity',
  } as ColumnType<AllergyTable, 'type'>,
  {
    header: strings.AllergyRecorder,
    accessor: 'recorder',
  } as ColumnType<AllergyTable, 'recorder'>,
  {
    header: strings.LabelAction,
    Cell: ({ row }) => <ActionCell row={row} update={update} isLoading={isLoading} />,
    accessor: 'id',
  } as ColumnType<AllergyTable, 'id'>,
];
